export const onMessageUpdatedOrDeleted = (channel, callback) => {
    channel.on('message.updated', callback);
    channel.on('message.deleted', callback);
    return () => {
        channel.off('message.updated', callback);
        channel.off('message.deleted', callback);
    };
};
